import React from 'react';
import KogAutoCompleteOutlinedControlled from '@/main/components/shared/inputAutoComplete/autoCompleteOutlinedControlled';
import { useFormContext, useWatch } from 'react-hook-form';
import { useBrandReducer } from '@/main/store/brand';
import { getTranslateByKey } from '@/main/services/utils';
import { KeyValue } from '@/main/models/common';
import { QuoteSupplierItemPartResponse } from '@/main/models/response';
import { PartTypeEnum } from '@/main/services/enum/PartTypeEnum';

interface IPartBrandInputProps {
  fieldPrefix: string;
  showFieldWithouEdit?: boolean;
  row: QuoteSupplierItemPartResponse;
}

export default function ColumnPartBrand({ fieldPrefix, showFieldWithouEdit, row }: IPartBrandInputProps) {
  const { control, setValue } = useFormContext();
  const { brand: brandReducer } = useBrandReducer();

  const watcherNotQuote = useWatch({
    control,
    name: `${fieldPrefix}.notQuote`,
    defaultValue: false
  });

  if (row.isInventoryResponse || showFieldWithouEdit || row.idPartType === PartTypeEnum.Tire) {
    return <>{row.idPartType !== PartTypeEnum.OEM ? row.partBrandName : 'N/A'}</>;
  }

  if (row.idPartType === PartTypeEnum.OEM) {
    return <>N/A</>;
  }

  return (
    <KogAutoCompleteOutlinedControlled
      id="id-createAnswer-txt-partBrandName"
      nameCustom={`${fieldPrefix}.partBrandName`}
      placeholder={getTranslateByKey('information.brand')}
      label=""
      control={control}
      disabled={watcherNotQuote}
      disabledMessage
      hideValue={watcherNotQuote}
      isDefaultValueUnique
      setValueCustom={setValue}
      options={brandReducer.data}
      isLoading={brandReducer.isLoading}
      onChangeCustom={(optionSelected: KeyValue | null) => {}}
    />
  );
}
